module.exports = __webpack_public_path__ + "img/soggetto.525ddccc.png";